<template>
  <div id="app">
    <popupTraining
      @closePopup="closePopup"
      @updateit="updateit"
      :state="state"
      :modelTrainPollutant="currentOptions"
      v-if="content === 'showpopup'"
      style=""
    ></popupTraining>
    <AccuracyViewer @closeAccuracy="closeAccuracy" v-if="showAccuracy" :Accuracy="accuracyData"></AccuracyViewer>
    <div class="row mt-4 justify-content-center pl-2" style="width: 100vw">
      <div class="col-sm-10 col-md-10 p-0">
        <div class="row justify-content-between">
          <h2 class="my-4 ml-3 col-sm-12 col-md-6 text-left">Last History</h2>
          <button v-if="count" @click="content='showpopup'; getCurrent('withoutFile', {})" class="my-4 ml-4 col-sm-5 col-md-2 pr-3">Forecast</button>
          <button @click="triggerEvent(2)" class="modelTrain my-4 col-sm-5 col-md-2 ml-4 pr-3 mr-3">Train Model</button>
        </div>
        <div class="table-responsive mb-4 pl-3">
          <table class="table table-bordered table-hover mb-0">
            <thead>
              <tr class="tableHeading">
                <th style="width: 5%">Name</th>
                <th style="width: 20%">pre-process</th>
                <th style="width: 25%">training</th>
                <th style="width: 20%">forecasting</th>
              </tr>
            </thead>
            <tbody v-if="lastTraining.length !== 0">
              <tr
                class="tableBodyFont"
                data-toggle="modal"
                data-target="#viewUser"
                v-for="(data, key) in lastTraining"
                :key="key"
              >
                <td>{{data['name']}}</td>
                <td>
                  <div v-if="!data['raw_file_name']">none</div>
                  <div v-else>
                    <div
                      v-if="data['pre_process'].status == 'none'"
                      @click="startPreprocess(data)"
                      class="cursor-pointer preprocess"
                    >Start Pre-processing</div>
                    <div v-else-if="data['pre_process'].status == 'Started' ">
                      <i class="fas fa-spinner fa-pulse mr-2"></i>going on
                    </div>
                    <div
                      v-else-if="data['pre_process'].status == 'Not Completed'"
                    >
                      <span>
                        <!-- {{data['pre_process'].file_status}} -->
                        <i
                          @mouseover="mousOverPopupGraph(data['_id'])"
                          data-original-title=""
                          title=""
                          data-placement="top" 
                          :data-toggle="data['_id']+'content'"
                          :data-content="data['pre_process'].file_status"
                          class="fas fa-exclamation-circle mr-2 cursor-pointer"
                          style="color: red;"
                        ></i>
                        <span
                          class="cursor-pointer"
                        >Some issue in file</span>
                      </span>
                    </div>
                    <div
                      v-else-if="data['pre_process'].status == 'Completed'"
                      @click="comingSoon(data['pre_process'].url)"
                    >
                      <i class="cursor-pointer fa fa-download" style="color: blue"></i>
                    </div>
                  </div>
                </td>
                <td>
                  <div v-if="!data['raw_file_name']">none</div>
                  <div v-else>
                    <div
                      v-if="data['training'].status == 'none' && data['pre_process'].status == 'none' || data['pre_process'].status == 'Not Completed' || data['pre_process'].status == 'Started'"
                    >none</div>
                    <div
                      v-else-if="data['pre_process'].status == 'Completed' && data['training'].status == 'none'"
                      @click="content='showpopup'; getCurrent('training', data)"
                      class="disableForPointer cursor-pointer"
                    >Start Training</div>
                    <div
                      v-else-if="data['training'].status == 'Started' && data['pre_process'].status == 'Completed'"
                    >
                      <i class="fas fa-spinner fa-pulse mr-2"></i>going on
                    </div>
                    <div class=""
                      v-else-if="data['training'].status == 'Completed'"
                    >
                      <i @click="comingSoon(data['training'].url)" title="download" class="cursor-pointer fa fa-download" style="color: blue"></i>
                      <span class="fs14 ml-3 cursor-pointer" title="check accuracy" @click="showAccuracy = !showAccuracy; accuracyData = data['training'].accuracy">View Accuracy</span>
                    </div>
                  </div>
                </td>
                <td>
                  <div
                    v-if="data['forecast'].status == 'none' && count"
                    class="cursor-pointer disableForecast"
                    @click="content='showpopup'; getCurrent('forecast', data)"
                  >Start Forecast</div>
                  <div v-else-if="data['forecast'].status == 'none' && !count">none</div>
                  <div v-else-if="data['forecast'].status == 'Started'">
                    <i class="fas fa-spinner fa-pulse mr-2"></i>going on
                  </div>
                  <div
                    v-else-if="data['forecast'].status == 'Completed'"
                    @click="comingSoon(data['forecast'].url)"
                  >
                    <i class="cursor-pointer fa fa-download" style="color: blue"></i>
                  </div>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <td class="pt-5 pb-5 text-center" colspan="6">
                  you have zero models....
                  <span
                    style="color: blue; text-decoration: underline"
                    class="cursor-pointer changePassword"
                    @click="triggerEvent(2)"
                  >Start using</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiCall } from "@/utils/api";
import popupTraining from "./popupTraining";
// import $ from "jquery";
import logo from '../assets/Logo_Final.png';
import Vue from 'vue';
import Swal from 'sweetalert2';
import Toasted from 'vue-toasted';
import AccuracyViewer from './helper/showAccuracy';

Vue.use(Toasted);
export default {
  name: "Tabel",
  props: {},
  components: {
    popupTraining: popupTraining,
    AccuracyViewer: AccuracyViewer
  },
  data() {
    return {
      price: 5000,
      showAccuracy: false,
      currentOptions: [],
      state: "",
      content: "",
      lastTraining: [],
      fields: ["", "pre_process", "training", "forecast"],
      count: 0,
      accuracyData: {},
       user: JSON.parse(localStorage.getItem('user'))
    };
  },
  watch: {},
  mounted() {
    this.getCount();
    this.getAllData();
    setInterval(() => {
      this.getAllData();
      this.getCount();
    }, 2000);
  },
  computed: {},
  methods: {
    mousOverPopupGraph(id) {
      /* eslint-disable */
      // $(`.popover-header`).remove();
      $(`[data-toggle=${id}content]`).popover({
        title: "",
        trigger: "hover",
      });
    },
    mousOverPopup(id) {
      /* eslint-disable */
      // $(`.popover-header`).remove();
      $(`[data-toggle=${id}report]`).popover({
        title: "",
        trigger: "hover",
      });
    },
    closeAccuracy() {
      this.showAccuracy = false;
    },
    getCount() {
      const url = `users_Model/getCount`;
      apiCall({ url, method: "get" })
        .then(resp => {
          this.count = resp.count;
          // this.step = 4;
        })
        .catch(err => {
          this.loaderShow = false;
          console.log(err);
        });
    },
    startPreprocess(data) {
      $(".preprocess").css("cursor", "none");
      const body = {
        raw_file_url: data.raw_file_url,
        raw_bucket_name: "ambee-forecast-auto-train",
        raw_file_name: data.raw_file_name,
        numerical_features: data.numerical_features,
        datetime_column: data.datetime_column,
        fr: data.fr,
        method: data.method
      };
      const url = `auto_ml/${data._id}/preprocess`;
      apiCall({ url, data: body, method: "put" })
        .then(() => {
          setTimeout(() => {
            $(".preprocess").css("cursor", "pointer");
          }, 3000);
          this.$toasted.show('Request submitted', { duration: 1000 })
          // this.step = 4;
        })
        .catch(err => {
          this.loaderShow = false;
          console.log(err);
        });
    },
    updateit() {
      if (this.state === "training") {
        $(".disableForPointer").css("cursor", "none");
        setTimeout(() => {
          $(".disableForPointer").css("cursor", "pointer");
          this.getAllData();
        }, 5000);
      } else if (this.state === "forecast") {
        $(".disableForecast").css("cursor", "none");
        setTimeout(() => {
          this.getCount()
          $(".disableForecast").css("cursor", "pointer");
          this.getAllData();
        }, 3000);
      } else if (this.state == 'withoutFile') {
        $(".disableForecast").css("cursor", "none");
        setTimeout(() => {
          this.getCount()
          $(".disableForecast").css("cursor", "pointer");
          this.getAllData();
        }, 3000);
      }
    },
    getCurrent(step, data) {
      // console.log(this.user,' user is here')
      if (this.user.payment) {
        this.content = 'showpopup'
        if (step === "training") {
            this.currentOptions = data;
            this.state = step;
          } else if (step === "forecast") {
            this.currentOptions = data;
            this.state = step;
          } else if (step === 'withoutFile') {
            this.state = step
            this.currentOptions = data
          }
        } else {
          this.content = ""
          Swal.fire({
            title: "Only Paid Service",
            text: `Please make payment`,
            type: "success",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Start Payment"
          }).then(result => {
            if (result.value) {
              this.getpayment()
              this.step = 1
            } else {
              this.step = 1
            }
          });
        }
    },
    closePopup() {
      this.content = "";
    },
    comingSoon(data) {
      
      apiCall({url: `auto_ml/file`, data:{data}, method: "post"}).then((res) => {
        let blob = new Blob([res.data], {
          type: 'application/octet-stream; charset=UTF-8'
        }),
        /*eslint-disable */
        url = window.URL || window.webkitURL,
        fileUrl = url.createObjectURL(blob);
        var anchor = document.createElement('a');
      anchor.href = fileUrl;
      anchor.target = '_blank';
      anchor.download = 'data.csv';
      anchor.style = "display: none";

      document.body.appendChild(anchor);
      anchor.click();
      /*eslint-disable */
      setTimeout(function() {
        document.body.removeChild(anchor);
        $window.URL.revokeObjectURL(fileUrl);
      }, 100);
      }).catch((err) => {
        console.log('err is here', err)
      })
      // window.open(data);
    },
    getValue(data, field, key) {
      return field === "" ? key : data.status;
    },
    getpayment() {
      const options = {
        key: 'rzp_live_J4PaDX6yFUjDFR',
        // amount: 5000,
        name: 'Ambee',
        currency: 'INR',
        description: `subsribe for one month`,
        image: logo,
        handler: (response) => {
          this.verifySignature(response)
        },
        prefill: {
          name: JSON.parse(localStorage.getItem('user')).name,
          email: JSON.parse(localStorage.getItem('user')).email,
        },
        notes: {
          address: JSON.parse(localStorage.getItem('user')).address,
        },
        theme: {
          color: '#2295C8',
        },
      }
      const url = 'payment/order'
      const body = {
        amount: this.price * 100,
        email: JSON.parse(localStorage.getItem('user')).email,
      }
      apiCall({ url, data: body, method: 'post' })
        .then((res) => {
          // console.log('res is here', res)
          this.loaderShow = false
          /* eslint-disable */
          const rzp1 = new Razorpay({ ...options, order_id: res.orderId })
          rzp1.open()
        })
        .catch((err) => { console.log('ERR', err) })
    },
    verifySignature(response) {
      this.loaderShow = true
      const url = 'payment/confirmPayment'
      apiCall({ url, data: { payment: response }, method: 'post' }).then((res) => {
        delete res.userUpdated._id;
        delete res.userUpdated.password;
        localStorage.setItem('user', JSON.stringify(res.userUpdated))
        localStorage.setItem('user-token', res.token);
        this.user = res.userUpdated;
        this.loaderShow = false
        Swal.fire({
          title: 'Awesome !',
          text: 'payment successfully !',
          type: 'success',
        })
      }).catch((err) => {
        console.log('error', err)
      })
    },
    getAllData() {
      const url = "auto_ml";
      apiCall({ url, method: "get" })
        .then(resp => {
          this.lastTraining = resp.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    triggerEvent() {
      this.$emit("update", 2);
    }
  }
};
</script>


<style scoped>
.tooltip {
  display: block !important;
  z-index: 10000;
}

.tooltip .tooltip-inner {
  background: black;
  color: white;
  border-radius: 16px;
  padding: 5px 10px 4px;
}

.tooltip .tooltip-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 5px;
  border-color: black;
  z-index: 1;
}

.tooltip[x-placement^="top"] {
  margin-bottom: 5px;
}

.tooltip[x-placement^="top"] .tooltip-arrow {
  border-width: 5px 5px 0 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  bottom: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="bottom"] {
  margin-top: 5px;
}

.tooltip[x-placement^="bottom"] .tooltip-arrow {
  border-width: 0 5px 5px 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-top-color: transparent !important;
  top: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="right"] {
  margin-left: 5px;
}

.tooltip[x-placement^="right"] .tooltip-arrow {
  border-width: 5px 5px 5px 0;
  border-left-color: transparent !important;
  border-top-color: transparent !important;
  border-bottom-color: transparent !important;
  left: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip[x-placement^="left"] {
  margin-right: 5px;
}

.tooltip[x-placement^="left"] .tooltip-arrow {
  border-width: 5px 0 5px 5px;
  border-top-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  right: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip.popover .popover-inner {
  background: #f9f9f9;
  color: black;
  padding: 24px;
  border-radius: 5px;
  box-shadow: 0 5px 30px rgba(black, 0.1);
}

.tooltip.popover .popover-arrow {
  border-color: #f9f9f9;
}

.tooltip[aria-hidden="true"] {
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.15s, visibility 0.15s;
}

.tooltip[aria-hidden="false"] {
  visibility: visible;
  opacity: 1;
  transition: opacity 0.15s;
}


.prev,
.next {
  width: 50px;
  height: 50px;
  color: black;
  cursor: pointer;
  text-align: center;
  transition: all 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}
.next:active {
    transform: translate(0, 3px) scale(1.2);
  }
.next:hover {
    /* background: white; */
    color: black;
    transform: scale(1.2);
  }
.next {
  right: 0;
  margin-left: auto;
  margin-right: 25px;
  text-indent: 2px;
}
button {
  width: 9rem;
  height: 3rem;
  border: none;
  color: white;
  background: cadetblue;
  border-radius: 20px;
}
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.4s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 300px;
  margin: 0px auto;
  padding: 20px 30px;
  min-height: 35px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.2s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-default-button {
  float: right;
}
.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(0.95);
  transform: scale(0.95);
}
.cursor-pointer {
  cursor: pointer;
}
.fs14{
 font-size: 1rem;
}
.logoutFont {
  color: white;
  font-size: 1rem;
  font-weight: bolder;
}
</style>
